import { z } from 'zod';

/** Minimal user snippet embedded in list/detail payloads (UCH-444). */
export const UserRefSchema = z.object({
  id: z.string().uuid(),
  displayName: z.string(),
  email: z.string().email(),
  /** photo_url (Firebase picture) ?? github_avatar_url; null when neither exists. */
  avatarUrl: z.string().nullable(),
});
export type UserRef = z.infer<typeof UserRefSchema>;
